<template>
  <div class="lasttrades" style="min-width: 0">
    <div class="icon">
      <img src="../../assets/icons/time-is-money1.svg" alt="" />
      <span> آخرین معاملات بازار ها </span>
    </div>
    <div v-if="coins.length" class="hooper-container" style="min-width: 0">
      <VueSlickCarousel v-bind="settings" style="min-width: 0">
        <div
          v-for="(item, index) in coins"
          :key="index"
          class="slide-container"
          style="min-width: 0"
        >
          <div class="slide-item" dir="ltr">
            <div class="row">
              <div class="coin-label">
                <div class="changes">
                  <span
                    :class="
                      item.last24HoursChange > 0
                        ? 'success'
                        : item.last24HoursChange < 0
                        ? 'fail'
                        : ''
                    "
                  >
                    {{
                      item.last24HoursChange > 0
                        ? $toLocal(item.last24HoursChange, 2) + "+"
                        : $toLocal(Math.abs(item.last24HoursChange)) + "-"
                    }}
                  </span>
                  <inline-svg
                    :class="
                      item.last24HoursChange > 0
                        ? 'success'
                        : item.last24HoursChange < 0
                        ? 'fail'
                        : ''
                    "
                    :src="require('../../assets/icons/changes.svg')"
                    alt=""
                  />
                </div>
                <img :src="$newCoins[item.relatedCoin].link" alt="" />
              </div>
              <span class="coin-label persianName">
                {{ $newCoins[item.relatedCoin].persianName }}
              </span>
              <span class="coin-label">
                {{ $newCoins[item.relatedCoin].code }}
              </span>
            </div>
            <div class="row">
              <span v-if="sourc_coin == 'TOMAN'" class="coin-label">
                <img :src="'/coins/TOMAN.png'" alt="" />
                تومان
              </span>
              <span v-else class="coin-label">
                <img :src="'/coins/TETHER.png'" alt="" />
                تتر
              </span>
              <span class="coin-label">
                {{ $toLocal(item.lastPrice, sourc_coin == "TOMAN" ? 0 : 2) }}
              </span>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
      <!-- <Hooper :settings="hoopersSetting">
        <Slide v-for="(item, index) in coins" :key="index" class="trade-info">
          <div class="row">
            <div class="coin-label">
              <div class="changes">
                <span :class="item.last24HoursChange > 0 ? 'success' : 'fail'">
                  {{
                    item.last24HoursChange > 0
                      ? $toLocal(item.last24HoursChange, 2) + "+"
                      : $toLocal(Math.abs(item.last24HoursChange)) + "-"
                  }}
                </span>
                <inline-svg
                  :class="item.last24HoursChange > 0 ? 'success' : 'fail'"
                  :src="require('../../assets/icons/changes.svg')"
                  alt=""
                />
              </div>
              <img :src="$newCoins[item.relatedCoin].link" alt="" />
            </div>
            <span class="coin-label">
              {{ $newCoins[item.relatedCoin].persianName }}
            </span>
            <span class="coin-label">
              {{ $newCoins[item.relatedCoin].code }}
            </span>
          </div>
          <div class="row">
            <span v-if="sourc_coin == 'TOMAN'" class="coin-label">
              <img :src="'/coins/TOMAN.png'" alt="" />
              تومان
            </span>
            <span v-else class="coin-label">
              <img :src="'/coins/TETHER.png'" alt="" />
              تتر
            </span>
            <span class="coin-label">
              {{ $toLocal(item.lastPrice, 0) }}
            </span>
          </div>
        </Slide>
      </Hooper> -->
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
export default {
  name: "LastTrades",
  components: {
    // Hooper,
    // Slide,
    VueSlickCarousel,
  },
  data() {
    return {
      settings: {
        arrows: false,
        dots: false,
        rtl: true,
        slidesToShow: 6,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 300,
        infinite: true,
        rows: 1,
        // centerMode: true,
        // variableWidth: true,
        responsive: [
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              centerMode: true,
            },
          },
        ],
      },
      // hoopersSetting: {
      //   rtl: true,
      //   infiniteScroll: true,
      //   autoPlay: true,
      //   autoplaySpeed: 4000,
      //   itemsToShow: 3,
      //   centerMode: true,
      //   breakpoints: {
      //     2200: {
      //       itemsToShow: 10,
      //       centerMode: true,
      //     },
      //     2000: {
      //       itemsToShow: 8,
      //       centerMode: true,
      //     },
      //     1700: {
      //       itemsToShow: 6,
      //       centerMode: true,
      //     },
      //     1200: {
      //       itemsToShow: 4,
      //       centerMode: true,
      //     },
      //     800: {
      //       itemsToShow: 3,
      //       centerMode: true,
      //     },
      //     500: {
      //       itemsToShow: 2,
      //     },
      //     320: {
      //       itemsToShow: 1,
      //       centerMode: true,
      //     },
      //   },
      // },
    };
  },
  props: ["allCoins", "sourc_coin"],
  computed: {
    coins() {
      let coin;
      coin = this.allCoins.filter((a) =>
        a.marketType.includes(this.sourc_coin)
      );
      return coin;
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  direction: ltr;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  .coin-label {
    display: flex;
    flex-direction: row-reverse;
    column-gap: 4px;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
    }
    .changes {
      display: flex;
      flex-direction: column;
    }
  }
}
.hooper-container {
  width: 100%;
  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (min-width: 1000px) {
    margin-left: -10px;
  }
  .hooper-list {
    background: unset !important;
  }
}
.tomany {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  column-gap: 4px;
}
.coin-img {
  max-width: 40px;
  max-height: 40px;
}
.lasttrades {
  z-index: 3;
  gap: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.icon {
  // width: 20%;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  column-gap: 12px;
  align-items: center;
}
@media only screen and (max-width: 1000px) {
  .icon {
    padding: 0 16px;
  }
  .lasttrades {
    flex-wrap: wrap;
  }
}
.slide-container {
  padding: 0 10px;
  width: 100%;
  .slide-item {
    background-color: #fff !important;
    width: 100%;
    padding: 8px 12px;
    border-radius: 8px;
  }
}
.persianName {
  padding: 0 4px;
  text-align: center;
}
</style>
